import { Chip, ChipProps } from '@material-ui/core';

import { IdentityRefFragment } from '@spotify/confidence-graphql';

import { identityKind } from '../../utils';
import { IdentityAvatarMui as IdentityAvatar } from '../IdentityAvatar';

type IdentityChipMuiProps = ChipProps & {
  identityRef: IdentityRefFragment;
};

/** @deprecated Legacy MUI copy — migrate consumers to the Encore IdentityChip and delete. */
export const IdentityChipMui = (props: IdentityChipMuiProps) => {
  const { identityRef, ...rest } = props;
  const isUser = identityKind(identityRef.name) === 'user';

  return (
    <Chip
      {...(isUser ? { 'data-csr-mask': true } : {})}
      avatar={<IdentityAvatar identityRef={identityRef} />}
      label={identityRef.displayName}
      {...rest}
    />
  );
};
